(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8573],{

/***/ 78110:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/500",
      function () {
        return __webpack_require__(32532);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports encodeImageUrl, seoKeys, emptySeo */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12104);




var encodeImageUrl = function(baseUrl, params) {
    // Remove double slashes from the URL path (except for the protocol part)
    var correctedBaseUrl = baseUrl.replace(/([^:]\/)\/+/g, "$1");
    var queryString = Object.keys(params).map(function(key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
    }).join("&");
    return "".concat(correctedBaseUrl, "?").concat(queryString);
};
var seoKeys = {
};
for(var key in seoKeys){
    seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}
var emptySeo = {
    title: " ",
    description: "",
    keywords: ""
};
var SeoMetaData = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
            title: data.title,
            description: data.description || "",
            additionalMetaTags: [
                {
                    name: "title",
                    content: data.title
                },
                {
                    name: "keywords",
                    content: data.keywords
                },
                {
                    name: "description",
                    content: data.description
                }, 
            ],
            openGraph: {
                title: data.title,
                description: data.description || "",
                images: data.image ? [
                    {
                        url: (0,_createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__/* .createImageApiUrl */ .h)(data.image.imageUrl),
                        alt: data.image.alt,
                        width: 1200,
                        height: 630
                    }, 
                ] : []
            },
            noindex: data.noIndex,
            nofollow: data.noIndex
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(SeoMetaData));


/***/ }),

/***/ 12104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ createImageApiUrl; }
/* harmony export */ });
function createImageApiUrl(originalUrl) {
    var baseUrl = "https://www.mazda.co.il";
    var apiUrl = "https://api.mazda.co.il";
    if (!baseUrl || !apiUrl) {
        throw new Error("Environment variables ORIGIN and API_URL must be set");
    }
    // Extract the relative path from the original URL
    var relativePath = originalUrl.replace(apiUrl, "");
    // Construct the API URL
    return "".concat(baseUrl, "/api/ogimage").concat(encodeURI(relativePath));
}


/***/ }),

/***/ 97294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$L": function() { return /* binding */ StyledHeaderSubtitle; },
/* harmony export */   "$v": function() { return /* binding */ StyledTh; },
/* harmony export */   "EF": function() { return /* binding */ StyledLi; },
/* harmony export */   "Fg": function() { return /* binding */ StyledLink; },
/* harmony export */   "GI": function() { return /* binding */ StyledTd; },
/* harmony export */   "PW": function() { return /* binding */ StyledSmallText; },
/* harmony export */   "SG": function() { return /* binding */ StyledThead; },
/* harmony export */   "TK": function() { return /* binding */ StyledSubtitle; },
/* harmony export */   "ZN": function() { return /* binding */ StyledBody2; },
/* harmony export */   "aG": function() { return /* binding */ StyledTr; },
/* harmony export */   "eX": function() { return /* binding */ StyledH3; },
/* harmony export */   "hc": function() { return /* binding */ StyledUl; },
/* harmony export */   "k6": function() { return /* binding */ StyledTable; },
/* harmony export */   "vc": function() { return /* binding */ StyledBody; },
/* harmony export */   "x0": function() { return /* binding */ StyledHeaderH2; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22318);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        "px;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 20px;\n  margin-top: ",
        "px;\n  font-weight: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n  ",
        ";\n  letter-spacing: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n  ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  margin-top: 40px;\n  font-family: "OENaPro";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 34px;\n  letter-spacing: 0.05em;\n  color: ',
        ";\n  ",
        " {\n    max-width: 300px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0px;\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n  &::marker {\n    font-size: 10px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: underline;\n  ",
        ";\n  color: ",
        ";\n  ",
        ";\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  margin-top: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-collapse: collapse;\n  text-align: right;\n  margin-top: 10px;\n  ",
        " {\n    display: block;\n    width: ",
        ";\n    overflow: auto;\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n  ",
        " {\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: normal;\n  td:first-child {\n    font-size: 16px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  padding: 7px 7px;\n  font-size: 16px;\n  line-height: 1;\n  font-weight: normal;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 7px 5px;\n  border: 1px solid ",
        ";\n  font-size: 18px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}


var StyledHeaderH2 = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "BodyText__StyledHeaderH2",
    componentId: "sc-971327b-0"
})(_templateObject(), function(p) {
    return p.$position && "text-align: ".concat(p.$position);
}, function(p) {
    return p.$margin && "margin-top: ".concat(p.$margin);
}, function(p) {
    return p.$fontSize ? "".concat(p.$fontSize, "px") : "24px";
}, function(p) {
    return p.$fontWeight ? p.$fontWeight : "400";
});
var StyledSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledSubtitle",
    componentId: "sc-971327b-1"
})(_templateObject1(), function(p) {
    return p.$margin;
}, function(p) {
    return p.$fontWeight ? p.$fontWeight : "bold";
});
var StyledHeaderSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledHeaderSubtitle",
    componentId: "sc-971327b-2"
})(_templateObject2(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "20px";
}, function(p) {
    return p.$position && "text-align: ".concat(p.$position);
});
var StyledBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "BodyText__StyledBody",
    componentId: "sc-971327b-3"
})(_templateObject3(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "10px";
}, function(p) {
    return p.$position && "text-align: ".concat(p.$position);
}, function(p) {
    return p.$fontSize ? "".concat(p.$fontSize, "px") : "18px";
});
var StyledH3 = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledH3",
    componentId: "sc-971327b-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledUl = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    displayName: "BodyText__StyledUl",
    componentId: "sc-971327b-5"
})(_templateObject5(), function(p) {
    return p.$padding && "padding-right: ".concat(p.$padding, "px");
});
var StyledLi = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    displayName: "BodyText__StyledLi",
    componentId: "sc-971327b-6"
})(_templateObject6(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "0px";
});
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    displayName: "BodyText__StyledLink",
    componentId: "sc-971327b-7"
})(_templateObject7(), function(p) {
    return p.$margin && "margin-top: ".concat(p.$margin, "px");
}, function(p) {
    return p.$color ? p.$color : p.theme.colors.mazdaRed;
}, function(p) {
    return p.$display && "display: ".concat(p.$display);
}, function(p) {
    return p.$fontSize && "font-size: ".concat(p.$fontSize, "px");
});
var StyledSmallText = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledSmallText",
    componentId: "sc-971327b-8"
})(_templateObject8(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "10px";
}, function(p) {
    return p.$fontWeight && "font-weight: ".concat(p.$fontWeight);
});
var StyledBody2 = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "BodyText__StyledBody2",
    componentId: "sc-971327b-9"
})(_templateObject9(), function(p) {
    return p.$fontSize && "font-size: ".concat(p.$fontSize, "px");
}, function(p) {
    return p.$margin && "margin-top: ".concat(p.$margin, "px");
});
var StyledTable = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].table.withConfig */ .ZP.table.withConfig({
    displayName: "BodyText__StyledTable",
    componentId: "sc-971327b-10"
})(_templateObject10(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$width ? p.$width : "350px";
}, function(p) {
    return p.theme.breakpoints.down("xs");
}, function(p) {
    return p.$width ? p.$width : "90vw";
});
var StyledThead = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].thead.withConfig */ .ZP.thead.withConfig({
    displayName: "BodyText__StyledThead",
    componentId: "sc-971327b-11"
})(_templateObject11());
var StyledTr = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].tr.withConfig */ .ZP.tr.withConfig({
    displayName: "BodyText__StyledTr",
    componentId: "sc-971327b-12"
})(_templateObject12(), function(p) {
    return p.theme.colors.black;
});
var StyledTh = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].th.withConfig */ .ZP.th.withConfig({
    displayName: "BodyText__StyledTh",
    componentId: "sc-971327b-13"
})(_templateObject13(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.colors.darkGrey;
});
var StyledTd = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].td.withConfig */ .ZP.td.withConfig({
    displayName: "BodyText__StyledTd",
    componentId: "sc-971327b-14"
})(_templateObject14(), function(p) {
    return p.theme.colors.darkGrey;
});


/***/ }),

/***/ 32532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _500; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(25384);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./reusable/wrappers/BodyText.tsx
var BodyText = __webpack_require__(97294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
;// CONCATENATED MODULE: ./components/pages/error/500Page.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  display: flex;\n  align-items: center;\n  max-width: 1400px;\n  padding: 100px;\n  p {\n    margin-top: 10px;\n  }\n  h6 {\n    margin-top: 10px;\n  }\n\n  ",
        " {\n    flex-direction: column-reverse;\n    padding: 0px;\n    padding-top: 70px;\n    padding-bottom: 50px;\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 50%;\n  height: 100%;\n  img {\n    ",
        " {\n      width: 549px;\n      height: 364px;\n    }\n  }\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var StyledPageDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "sc-500Page__StyledPageDiv",
    componentId: "sc-4d54939-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "sc-500Page__StyledWrapper",
    componentId: "sc-4d54939-1"
})(_templateObject1(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "sc-500Page__StyledImage",
    componentId: "sc-4d54939-2"
})(_templateObject2());
var Page500 = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledPageWrapper */.S0, {
        $padding: "0",
        $background: "#F5F5F5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPageDiv, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h2",
                            children: "משהו השתבש"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "subtitle1",
                            children: "משהו לא עובד ואנחנו עובדים על לתקן את זה."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "body1",
                            children: [
                                " ",
                                "אם זה עניין דחוף ניתן להתקשר",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLink */.Fg, {
                                    $color: " #101010",
                                    children: "לשירות הלקוחות שלנו"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "body1",
                            children: [
                                "בבקשה נסו שוב מאוחר יותר, ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "סליחה ותודה על הסבלנות."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                        src: "/img/500.png"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var _500Page = (Page500);

;// CONCATENATED MODULE: ./src/pages/500/index.tsx



var ServerError = function(param) {
    var seo = param.seo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
                data: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(_500Page, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _500 = (ServerError);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(78110); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);